export default "__VITE_ASSET__db287ecb__"